import type { Dictionnaire } from '../type';

export const lieux: Dictionnaire['lieux'] = {
  carte: '地点地图',
  filtrer: '筛选地点',
  tout: '全部',
  rapproche: '放大地图以查看地点',
  recherche: '正在查找地点…',
  fermer: '关闭',
  appeler: '拨打电话',
  chercherSurLeWeb: '在网上搜索',
  chercher: '搜索活动类型',
  exemple: '游泳池、体育场…',
  effacer: '清除',
  rienTrouve: '附近没有找到',
  creerUnEvenement: '在这里创建活动',
  aimer: '喜欢这个地点',
  nePlusAimer: '取消喜欢',
  familles: {
    restos: '餐饮',
    sorties: '娱乐',
    sport: '运动',
    culture: '文化',
    nature: '自然',
    commerces: '商店',
  },
  categories: {
    Restaurant: '餐厅',
    Cafe: '咖啡馆',
    Bakery: '面包店',
    Nightlife: '酒吧',
    Brewery: '啤酒厂',
    Winery: '酒庄',
    Distillery: '蒸馏酒厂',
    MovieTheater: '电影院',
    Theater: '剧院',
    MusicVenue: '音乐厅',
    Bowling: '保龄球馆',
    MiniGolf: '迷你高尔夫',
    GoKart: '卡丁车',
    AmusementPark: '游乐园',
    Stadium: '体育场',
    Soccer: '足球',
    Tennis: '网球',
    Basketball: '篮球',
    Swimming: '游泳池',
    Volleyball: '排球',
    Golf: '高尔夫',
    Skating: '溜冰场',
    RockClimbing: '攀岩',
    SkatePark: '滑板公园',
    FitnessCenter: '健身房',
    Museum: '博物馆',
    Landmark: '地标',
    Castle: '城堡',
    Fortress: '要塞',
    NationalMonument: '国家纪念地',
    Library: '图书馆',
    Planetarium: '天文馆',
    Aquarium: '水族馆',
    Zoo: '动物园',
    Park: '公园',
    Beach: '海滩',
    Hiking: '徒步',
    NationalPark: '国家公园',
    Marina: '游艇码头',
    Store: '商店',
    FoodMarket: '市场',
  },
};
